<script>
export default {
  name: "NewDocument",
  data() {
    return {
      isEnabled: true,
      fileList: [],
      form: {
        folderName: "",
        CreatedBy: this.$store.state.user.user.UserID,
        CompanyCode: this.$store.state.user.user.CompanySelected,
        fileListResponse: []
      },
      rules: {
        folderName: [{ required: true, trigger: "blur", message: "Requerido" }]
      },
      categoriesValue: [],
      count: 0,
      postUrl: "/api/Folder/Create", //ruta de ejemplo
      successMessage: "Carpeta creada correctamente" //mensaje de exito de subida de archivo de ejemplo
    };
  },
  computed: {
    totalUploadFiles() {
      return this.$refs.uploadFile.uploadFiles.length;
    }
  },
  methods: {
    onCancel() {
      this.fileList = [];
      this.form = {};
      this.$emit("dialog-closed");
      this.$refs.form_create.resetFields();
    },
    saveDocument() {
      this.$refs.form_create.validate((valid) => {
        if (valid) {
          this.$refs.uploadFile.submit();
        } else {
          return false;
        }
      });
    },
    handleUploadOnSuccess(response /*, file, fileList*/) {
      /*
      console.log("handleUploadOnSuccess");
      console.log("response =>", response);
      console.log("file => ", file);
      console.log("fileList => ", fileList);
      */
      this.isEnabled = false;
      const items_count = response.length;
      for (var index = 0; index < items_count; index++) {
        if (items_count > 0) {
          this.fileList.push({
            name: response[index].Name,
            url: response[index].Url
          });
        }
      }
      this.count++;
    },
    handleError(/*err, file, fileList*/) {
      //console.log(err, file, fileList);
    }
  },
  watch: {
    count(val) {
      let self = this;
      if (val === this.totalUploadFiles) {
        this.form.fileListResponse = this.fileList;
        this.$http
          .post(this.postUrl, self.form)
          .then(() => {
            self.$emit("dialog-closed");

            self.$message({
              type: "success",
              message: self.successMessage
            });

            self.$emit("success");
          })
          .catch((err) => {
            self.$message({ type: "error", message: err.message });
          })
          .finally(() => {
            self.count = 0;
            self.form = {};
            self.fileList = [];
            self.$refs.form_create.resetFields();
          });
      }
    }
  }
};
</script>

<style scoped>
.title {
  /* Nuevo Documento */

  position: absolute;
  width: 143px;
  height: 19px;
  left: 20px;
  top: 52px;

  margin-left: 35%;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  /* identical to box height */

  color: #2484c4;
}

label .el-form-item__label {
  /* Adjuntar documento */

  width: 188px;
  height: 18px;

  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;

  color: #3c3c3c;
}

label {
  color: #bf3636;
  margin-top: 5px;
  margin-bottom: 5px;
}
ul > li > label > .el-upload-list--picture .el-upload-list__item-status-label {
  position: absolute;
  right: -17px;
  top: -7px;
  width: 46px;
  height: 26px;
  background: #5f8fdf;
  text-align: center;
  transform: rotate(45deg);
  box-shadow: 0 1px 1px #ccc;
}
</style>
